import {
  useSignSelectListLazyQuery,
  useTollingPointNamesLazyQuery,
  useTollingPricingListLazyQuery,
} from '@kinetic-ui/data-layer';
import { DataSource, FormOption } from '@qfa/forms';
import { getNodes } from 'kineticUtils/data/getNodes';
import { useCallback } from 'react';

export const useTollingAlarmEntityDataSource = (): DataSource<FormOption[]> => {
  // fetch tolling point entities
  const [getTollingPointNames] = useTollingPointNamesLazyQuery();

  // fetch tolling pricing entities
  const [getTollingPricingNames] = useTollingPricingListLazyQuery({
    variables: {
      limit: 10000,
    },
  });

  // fetch signs
  const [getSigns] = useSignSelectListLazyQuery();

  const load = useCallback(async () => {
    const { data } = await getTollingPointNames();
    const dataSourceOptions = getNodes(data?.tollingPoints).map((tollingPoint) => ({
      label: tollingPoint.name,
      value: tollingPoint.id,
    }));

    const { data: pricingData } = await getTollingPricingNames();
    const pricingOptions = getNodes(pricingData?.tollingPricingList).map((pricing) => ({
      label: pricing.name,
      value: pricing.id,
    }));

    const { data: signData } = await getSigns();
    const signOptions = getNodes(signData?.signs).map((sign) => ({
      label: sign.name,
      value: sign.id,
    }));

    dataSourceOptions.push(...signOptions);
    dataSourceOptions.push(...pricingOptions);

    // Sort options alphabetically
    const options = dataSourceOptions.sort((a, b) => a.label.localeCompare(b.label));

    return options as FormOption[];
  }, [getTollingPointNames, getTollingPricingNames, getSigns]);

  return { load };
};
